import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EActionState, IAppointmentCombinedState, IListValue } from 'models';
import { resetState } from 'store/common/slice';
import { initialState } from './state';

const slice = createSlice({
	name: '@@followups/close',
	initialState,
	reducers: {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		INIT_START: (state, action: PayloadAction<{ activityId: string; opportunityId: string; onSuccess: () => PayloadAction<any> }>) => {
			state.init = EActionState.RUNNING;
			state.activityId = action.payload.activityId;
			state.opportunityId = action.payload.opportunityId;
			state.onSuccess = action.payload.onSuccess;
		},
		INIT_COMPLETED: (state, action: PayloadAction<{ followUps: IAppointmentCombinedState[]; reasonCodes: IListValue[] }>) => {
			state.init = EActionState.COMPLETED;
			state.followUps = action.payload.followUps;
			state.reasonCodes = action.payload.reasonCodes;
		},
		INIT_FAILED: state => {
			state.init = EActionState.FAILED;
		},
		INIT_FLUSH: state => {
			resetState(state, initialState);
		},
		CLOSE_START: state => {
			state.close = EActionState.RUNNING;
		},
		CLOSE_COMPLETED: state => {
			state.close = EActionState.COMPLETED;
		},
		CLOSE_FAILED: state => {
			state.close = EActionState.FAILED;
		},
		OPEN_DIALOG: state => {
			state.open = true;
		},
		CLOSE_DIALOG: state => {
			state.open = false;
		},
		SET_REASON_FOR_NO_PURCHASE: (state, action: PayloadAction<string>) => {
			state.form.formData.reasonForNoPurchase.newValue = action.payload;
		},
		SET_COMMENTS: (state, action: PayloadAction<string>) => {
			state.form.formData.comments.newValue = action.payload;
		},
		RESET_FORM: state => {
			resetState(state.form, initialState.form);
		}
	}
});

export const { reducer } = slice;
export const actionCreator = slice.actions;
